export const BACKEND_SERVER = "http://localhost:3001";
export const FRONTEND_SERVER = "http://localhost:3000";
export const presenter = "Presenter";
export const seller = "Company";
export const owner = "Owner";
export const FILE_SIZE = 2000000;
export const SUPPORTED_FORMATS_EXCEL = ["application/vnd.openxmlformats-officedocument.spreadsheetml.sheet","application/vnd.ms-excel", "text/csv", "image/png","image/jpeg"]
export const SUPPORTED_FORMATS_IMAGE = ["image/png","image/jpeg"]
export const SUPPORTED_FORMATS_PDF = ["application/pdf"]
